import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { renderCheck } from 'routes/Portfolio/Component/ActivityTab/TopicsTab/helper';

export default function DailyCheckInHistory({ user, actions }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchHistory = async () => {
    try {
      setLoading(true);

      const result = await actions.getUserDailyCheckInHistory(user.userId);
      setHistory(result.checkIns || []);
    } catch (err) {
      setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <tr className="daily-checkin-history-row">
      <td colSpan={9} className="p-0">
        <div className="daily-checkin-history-container">
          {/* HEADER */}
          <div className="history-title font-weight-600 mb-2">
            Last 30 Daily Check-Ins
          </div>

          {/* LOADING */}
          {loading && (
            <div className="text-center my-4">
              <i className="fa fa-spinner fa-spin fa-2x" />
            </div>
          )}

          {/* EMPTY STATE */}
          {!loading && history.length === 0 && (
            <div className="text-center my-3">No check-ins found.</div>
          )}

          {/* HISTORY TABLE */}
          {!loading && history.length > 0 && (
            <table className="daily-checkin-history-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th className="text-center">Logged In</th>
                  <th className="text-center">Pinned</th>
                  <th className="text-center">Device</th>
                  <th className="text-center">Browser</th>
                  <th className="text-center">Version</th>
                </tr>
              </thead>

              <tbody>
                {history.map((entry) => (
                  <tr key={entry._id}>
                    <td>{moment(entry.time).format('MM/DD/YYYY HH:mm')}</td>
                    <td className="text-center">
                      {renderCheck(entry.isLoggedIn)}
                    </td>
                    <td className="text-center">
                      {renderCheck(entry.isPinned)}
                    </td>

                    <td className="text-center">{entry.device || '-'}</td>
                    <td className="text-center">{entry.browser || '-'}</td>
                    <td className="text-center">{entry.version || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </td>
    </tr>
  );
}
